import { Col, Row, DatePicker } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import CustomSearch from '../../../v2-components/Antd/Search';
import CustomTable from '../../../v2-components/Antd/Table';
import CustomTabs from '../../../v2-components/Antd/Tabs';
import CustomButton from '../../../v2-components/Antd/Button';
import { LOCAL_STORAGE } from '../../../v2-config/constants/local-storage.constant';
import { Service } from '../service';
import { statusPreparation } from './constants/status.constant';
import { typeDelivery } from './constants/type-delivery.constant';
import { generateColumns } from './handle/generate-columns.handle';
import { handleSearchParams } from './handle/search-params.handle';
import { tabOptions } from './handle/tab-options.handle';
import './style.css';
import Loading from '../../../v2-components/Loading';

export default function OrdersListPage() {
	const [data, setData] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [isTableLoading, setIsTableLoading] = useState(false);
	const history = useHistory();
	const location = useLocation();

	const searchParams = new URLSearchParams(location?.search);
	const page = searchParams.get('page');
	const statusQueryParam = searchParams.get('status');
	const [status, setStatus] = useState(statusQueryParam);
	const [deliveryType, setDeliveryType] = useState();
	const [paginationResponse, setPaginationResponse] = useState();
	const [orderSearchText, setOrderSearchText] = useState('');
	const [dateRange, setDateRange] = useState(null);
	const [isDownloading, setIsDownloading] = useState(false);
	const rowKey = '_id';
	const { pharmacy, token } = GetLocalStorageValue(LOCAL_STORAGE.USER);
	const trxIdQueryParam = searchParams.get('trx_id');
	const [trxId, setTrxId] = useState(trxIdQueryParam);

	const pagination = {
		currentPage: paginationResponse?.currentPage,
		pageSize: paginationResponse?.itemsPerPage,
		totalItems: paginationResponse?.totalItems,
	};

	useEffect(() => {
		setIsTableLoading(true);
		new Service().getData({ status, page, pharmacy, delivery_type: deliveryType, trx_id: trxId }).then((response) => {
			setPaginationResponse(response);
			setData(response.data);
		}).catch((error) => {
      console.error("Error fetching data", error);
  })
  .finally(() => {
      setIsTableLoading(false);
      setIsLoading(false); 
  });
	}, [status, page, pharmacy, deliveryType, trxId]);

	const handlePageChange = (page) => {
		searchParams.set('page', page);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const onTabChange = () => {
		searchParams.set('page', 1);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
		setDeliveryType(typeDelivery[Enviroment.LANGUAGE].all.toLowerCase());
	};

	const handleStatusQueryChange = (status) => {
		searchParams.set('status', status);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};
	const handleOperationIdChange = (operation_id) => {
		if (operation_id === '') {
			setTrxId(null);
			searchParams.delete('trx_id');
		} else {
			setTrxId(operation_id);
			searchParams.set('trx_id', operation_id);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleDropdownSelect = (key) => {
		setStatus(key);
		handleStatusQueryChange(key);
	};
	const handleDropdownDelivery = (key) => {
		setDeliveryType(key);
	};

	const handleSearchOrder = (e) => {
		setOrderSearchText(e.target.value);
	};

	const handleDateChange = (dates) => {
		setDateRange(dates);
	};

	const handleDownload = async () => {
		try {
			setIsDownloading(true);
			const country = Enviroment.LANGUAGE;
			let from = null;
			let to = null;

			if (dateRange && dateRange[0] && dateRange[1]) {
				from = dateRange[0].format('YYYY-MM-DD');
				to = dateRange[1].format('YYYY-MM-DD');
			}

			const response = await new Service().exportPurchases(token, country, pharmacy, from, to);
			if (response && response.url) {
				const link = document.createElement('a');
				link.href = response.url;
				link.setAttribute('download', response.filename || 'compras-export.xlsx');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		} catch (error) {
			console.error('Error al descargar:', error);
		} finally {
			setIsDownloading(false);
		}
	};

	const handleTabClick = (key) => {
		const tab = tabOptions(data).find((tab) => tab.key === key);
		if (tab) {
			setStatus(tab.status);
			handleStatusQueryChange(tab.status);
			onTabChange();
		}
		const filteredData = tabOptions(data).map((tab) => ({
			...tab,
			data: tab.data?.filter((item) => {
				return item;
			}),
		}));

		return filteredData;
	};

	const paginationConfig = {
		current: pagination.currentPage,
		pageSize: pagination.pageSize,
		total: pagination.totalItems,
		showSizeChanger: false,
		onChange: (page) => handlePageChange(page),
	};

	const operations = (
		<div className="operations-container">
			<label className="date-range-label">Periodo a descargar</label>
			<div className="date-range-controls">
				<DatePicker.RangePicker
					format="YYYY-MM-DD"
					onChange={handleDateChange}
					placeholder={['Fecha desde', 'Fecha hasta']}
					className="date-picker"
				/>
				<CustomButton
					type="primary"
					icon={<DownloadOutlined />}
					onClick={handleDownload}
					className="download-button"
					loading={isDownloading}
					disabled={isDownloading}
				>
					{isDownloading ? 'Descargando...' : 'Descargar'}
				</CustomButton>
			</div>
		</div>
	);

	const initialActiveTab = tabOptions(data).find((tab) => tab.status === status)?.key;

	const itemsDropdownDelivery = [
		{
			key: 'todas',
			label: typeDelivery[Enviroment.LANGUAGE]['all'],
			value: 'all',
			onClick: (e) => handleDropdownDelivery(e.key),
		},
		{
			key: 'farmacia',
			label: typeDelivery[Enviroment.LANGUAGE]['pharmacy'],
			value: 'pharmacy',
			onClick: (e) => handleDropdownDelivery(e.key),
		},
		{
			key: 'domicilio',
			label: typeDelivery[Enviroment.LANGUAGE]['home'],
			value: 'home',
			onClick: (e) => handleDropdownDelivery(e.key),
		},
		{
			key: 'mixto',
			label: typeDelivery[Enviroment.LANGUAGE]['mixed'],
			value: 'mixed',
			onClick: (e) => handleDropdownDelivery(e.key),
		},
	];

	const itemsDropdownStatus = [
		{
			key: 'all',
			label: statusPreparation[Enviroment.LANGUAGE]['all'],
			value: 'null',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '001',
			label: statusPreparation[Enviroment.LANGUAGE]['001'],
			value: '001',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '002',
			label: statusPreparation[Enviroment.LANGUAGE]['002'],
			value: '002',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '003',
			label: statusPreparation[Enviroment.LANGUAGE]['003'],
			value: '003',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '101',
			label: statusPreparation[Enviroment.LANGUAGE]['101'],
			value: '101',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '201',
			label: statusPreparation[Enviroment.LANGUAGE]['201'],
			value: '201',
			onClick: (e) => handleDropdownSelect(e.key),
		},
	];

	if (isLoading) {
		return <Loading />;
	}
	if (isLoading === false) {
		return (
			<div className="tracking-orders-list-container">
				<Row>
					<Col span={8}>
						<h2>Ordenes de compra</h2>
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<Col className={'own-order-main-container'}>
							<CustomTabs
								tabBarExtraContent={operations}
								onChange={handleTabClick}
								activeKey={initialActiveTab}
								renderTabBar={(props, DefaultTabBar) => (
									<>
										<DefaultTabBar {...props} />
										<div className="order-search-below-tabs">
											<CustomSearch placeholder={'N° de orden'} onChange={handleSearchOrder} onSearch={() => handleOperationIdChange(orderSearchText)} />
										</div>
									</>
								)}
							>
								{handleTabClick().map((tab) => (
									<CustomTabs key={tab.key} tab={tab.tab}>
									<CustomTable
										dataSource={tab.data}
										columns={generateColumns(itemsDropdownDelivery, itemsDropdownStatus, status)}
										pagination={paginationConfig}
										rowKey={rowKey}
										loading={isTableLoading}
									/>
								</CustomTabs>
							))}
						</CustomTabs>
						</Col>
					</Col>
				</Row>
			</div>
		);
	}
}
